module.exports = __webpack_public_path__ + "media/images/favicons/120x120-d6e7af8b2fe9392f557f6005c9ba8d8c.png";